module.exports = {"650204001":"中兴路街道","650204002":"三平路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650204.json
// module id = 3060
// module chunks = 0